module.exports = __webpack_public_path__ + "static/img/smith-farm-historical-signs11.d535e02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/smith-farm/smith-farm-historical-signs11.jpg
// module id = 966
// module chunks = 0